export const GET_LEAD_CAPTURE_LIST = "/brain/v1/conversation/lead/list"
export const GET_LEAD_DATA_FOR_CSV = "/brain/v1/conversation/sheet/lead/list"

export const GET_DYNAMIC_LEAD_LIST = "/bot/v2/leads/list"
export const CREATE_DYNAMIC_LEAD = "/bot/v2/leads"
export const UPDATE_DYNAMIC_LEAD = "/bot/v2/leads/update-lead"
export const DELETE_DYNAMIC_LEAD = "/bot/v2/leads/delete-lead"
export const UPDATE_DYNAMIC_LEAD_LIST = "/bot/v2/leads/update-lead"